import { Controller } from "@hotwired/stimulus"

// One view slot on the look page: keeps the header in step with the stance
// picked below it.
//
// The header is what an operator actually reads — a column of thumbnails, one
// per view the guide requires. Picking a different stance in the (collapsed)
// grid changed only a radio deep in the list, so the thumbnail still showed the
// old stance until the page was saved and re-rendered. You could not see what
// you had chosen.
//
// Everything needed sits on the radio itself, so this never fetches: the
// thumbnail URL, the pose name and the orientation the stance actually shoots.
// That last one is why the "wrong way" flag can be kept honest live — assigning
// a front pose to a back view is legal but almost never intended.
export default class extends Controller {
  static targets = ["preview", "name", "badge"]
  static values  = { orientation: String }

  pick(event) {
    const radio = event.target
    if (!radio.checked) return

    const { thumb, poseName, orientation, mode } = radio.dataset
    this.renderPreview(thumb, mode)
    this.renderName(poseName, mode)
    this.renderBadge(orientation, mode)
    this.element.classList.toggle("rc-slot--skipped", mode === "skip")
  }

  renderPreview(thumb, mode) {
    if (!this.hasPreviewTarget) return

    const number = this.previewTarget.querySelector(".rc-slot__no")
    this.previewTarget.innerHTML = ""
    if (number) this.previewTarget.appendChild(number)

    if (thumb) {
      const img = document.createElement("img")
      img.src = thumb
      img.alt = ""
      this.previewTarget.appendChild(img)
    } else {
      const chip = document.createElement("span")
      chip.className = "rc-slot__text-chip"
      chip.textContent = mode === "skip" ? "skipped" : "text"
      this.previewTarget.appendChild(chip)
    }
  }

  renderName(poseName, mode) {
    if (!this.hasNameTarget) return

    if (mode === "skip") {
      this.nameTarget.textContent = "Not shot — the guide asks for this view."
    } else {
      this.nameTarget.textContent = poseName || ""
    }
  }

  // A three-quarter stance reads as a front view; nothing reads as a back one.
  renderBadge(orientation, mode) {
    if (!this.hasBadgeTarget) return

    const want = this.orientationValue
    const off  = mode === "pose" && (want === "back" ? orientation !== "back" : orientation === "back")
    this.badgeTarget.hidden = !off
  }
}
